<template>
  <div class="gx-ow">
    <top-banner
      :nav-items="navItems"
      :unread="unreadCount"
      @logo="goHome"
      @nav="onNav"
      @bell="goNotification"
      @legacy="goLegacy"
      @logout="logout"
    />

    <div class="gx-layout">
      <!-- 侧栏（新版 wb-ops 菜单） -->
      <aside class="gx-ow__sidebar" :style="{ width: collapsed ? '48px' : '210px' }">
        <button class="gx-ow__collapse" @click="collapsed = !collapsed">
          <span :style="{ transform: collapsed ? 'rotate(180deg)' : 'none' }">◀</span>
        </button>

        <nav class="gx-ow__nav">
          <button
            v-for="item in newUiVisibleItems('ops', menu)"
            :key="item.id"
            class="gx-ow__item"
            :class="{ 'gx-ow__item--on': activeId === item.id }"
            :title="collapsed ? item.label : undefined"
            @click="go(item)"
          >
            <span class="gx-ow__item-icon">{{ item.icon }}</span>
            <span v-if="!collapsed" class="gx-ow__item-label">{{ item.label }}</span>
          </button>
        </nav>
      </aside>

      <!-- 内容区 -->
      <main id="gx-main" class="gx-main">
        <!-- 店铺看板 -->
        <new-shop-board-detail-page v-if="activeId === 'ops-shop' && $route.query.detail" />
        <new-shop-board-page v-else-if="activeId === 'ops-shop'" @jump="go($event)"/>

        <!-- 商品看板 -->
        <new-product-board-page v-else-if="activeId === 'ops-goods'" />

        <!-- 任务大厅 -->
        <new-task-page v-else-if="activeId === 'ops-task'"></new-task-page>

        <!-- 任务模板（原版无此功能） -->
        <new-task-template-page v-else-if="activeId === 'ops-template'"></new-task-template-page>
<!--        <div v-else-if="activeId === 'ops-template'" class="gx-ow__placeholder">
          <div class="gx-ow__placeholder-icon">📋</div>
          <div class="gx-ow__placeholder-title">任务模板</div>
          <div class="gx-ow__placeholder-sub">任务模板功能为新增能力，原版无对应功能，页面开发中</div>
        </div>-->
      </main>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import TopBanner from '../../components/newUi/TopBanner.vue'

import NewShopBoardPage from '../shopBoard/index.vue'
// import NewShopBoardDetailPage from '../shopBoard/detail.vue'
import NewShopBoardDetailPage from '../shopBoard/detailOld.vue'
import NewProductBoardPage from '../productBoard/index.vue'
import NewTaskPage from '../task/index.vue'
import NewTaskTemplatePage from "../taskTemplate/index.vue"
import newUiPermissionMixin from '../../mixins/newUiPermission'

export default {
  name: 'NewOpsWorkbenchPage',
  mixins: [newUiPermissionMixin],
  components: { TopBanner, NewShopBoardPage, NewShopBoardDetailPage, NewProductBoardPage,NewTaskPage,NewTaskTemplatePage },
  data() {
    return {
      navItems: [
        { id: null, label: '星人工作台' },
        // { id: 'agent', label: 'Agent工作台' },
        { id: 'shop', label: '店铺工作台' },
        { id: 'finance', label: '财务工作台' },
        { id: 'ops', label: '运营工作台', active: true },
        // { id: 'select', label: '选品工作台' },
        { id: 'cloud', label: '云库工作台' },
        { id: 'presales', label: '售前工作台' },
        { id: 'aftersales', label: '售后工作台' },
        { id: 'system', label: '系统工作台' }
      ],
      // 新版 wb-ops 菜单（对照 ShopAdminPage.tsx WB_L2_DEFS["wb-ops"] 与 ICONS）
      menu: [
        { id: 'ops-shop', label: '店铺看板', icon: '📈', legacy: '/uc_shop_board' },
        { id: 'ops-goods', label: '商品看板', icon: '🛍️', legacy: '/uc_product_board' },
        { id: 'ops-task', label: '任务大厅', icon: '✅', legacy: '/uc_task_hall' },
        { id: 'ops-template', label: '任务模板', icon: '📋', legacy: '' }
      ],
      collapsed: false,
      activeId: 'ops-task',

    }
  },
  computed: {
    unreadCount() {
      const notifs = this.$store.state.notification.notifications || []
      return notifs.filter((n) => !n.isRead).length
    },
  },
  created() {
    const t = this.$route.query.menu
    if (t && this.menu.some((m) => m.id === t)) this.activeId = t
    this.$store.dispatch('notification/initNotificationWS')
  },
  methods: {
    ...mapMutations({
      OUT_LOGIN: 'login/OUT_LOGIN'
    }),
    go(item) {
      this.activeId = item.id
      if (this.$route.path !== '/new_ops_workbench' || this.$route.query.menu !== item.id) {
        this.$router.replace({ path: '/new_ops_workbench', query: { menu: item.id } }).catch(() => {})
      }
    },
    goLegacy() {
      this.$router.push('/ucenter_legacy')
    },
    onNav(id) {
      if (id === null) {
        this.$router.push('/ucenter')
        return
      }
      const map = {
        agent: '/new_uc_shop_manage',
        shop: '/new_uc_shop_manage',
        finance: '/new_finance_workbench',
        ops: '/new_ops_workbench',
        select: '/new_select_workbench',
        cloud: '/new_cloud_workbench',
        goods: '/new_goods_workbench',
        presales: '/new_presales_workbench',
        aftersales: '/new_aftersales_workbench',
        system: '/new_system_workbench'
      }
      const route = map[id]
      if (!route) {
        this.$message({ message: '该工作台功能开发中，敬请期待', type: 'warning' })
        return
      }
      this.$router.push(route)
    },
    goHome() {
      this.$router.push('/')
    },
    goNotification() {
      this.$router.push('/notification')
    },
    logout() {
      this.OUT_LOGIN()
      this.$message({ message: '已退出登录', type: 'success' })
      location.href = '/'
    },

  }
}
</script>

<style scoped>
.gx-ow {
  min-height: 100vh;
  background: #F4F6F8;
  font-family: 'Noto Sans SC', sans-serif;
}
.gx-ow__sidebar {
  flex-shrink: 0;
  background: #EEF1F6;
  border-right: 1px solid #DDE2EC;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  scrollbar-width: none;
  position: relative;
  transition: width .25s cubic-bezier(.4, 0, .2, 1);
}
.gx-ow__sidebar::-webkit-scrollbar {
  display: none;
}
.gx-ow__collapse {
  position: absolute;
  top: 10px;
  right: -12px;
  z-index: 20;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid rgba(212, 169, 70, .3);
  background: #EEF1F6;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all .25s;
}
.gx-ow__collapse:hover {
  background: #1a2040;
  border-color: #D4A946;
}
.gx-ow__collapse span {
  font-size: 10px;
  color: #A0AEC0;
  display: inline-block;
  transition: transform .25s;
}

.gx-ow__nav {
  flex: 1;
  padding: 8px 0;
  overflow-y: auto;
  scrollbar-width: none;
}
.gx-ow__item {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  padding: 0 14px;
  border: none;
  border-left: 3px solid transparent;
  background: transparent;
  cursor: pointer;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 13px;
  color: #5C6B73;
  text-align: left;
  transition: all .18s ease;
}
.gx-ow__item:hover {
  background: rgba(255, 255, 255, .72);
  color: #1A1A2E;
}
.gx-ow__item--on {
  background: #FFFFFF;
  border-left-color: #fa5757;
  color: #1A1A2E;
  font-weight: 500;
}
.gx-ow__item-icon {
  font-size: 15px;
  flex-shrink: 0;
}
.gx-ow__item-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.gx-ow__placeholder {
  text-align: center;
  padding: 80px 24px;
  border-radius: 16px;
  background: linear-gradient(135deg, #FFFFFF, rgba(15, 29, 66, .25));
  border: 1px solid #E1E5EE;
}
.gx-ow__placeholder-icon {
  font-size: 56px;
  margin-bottom: 16px;
}
.gx-ow__placeholder-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 18px;
  color: #4A4A6A;
  margin-bottom: 8px;
}
.gx-ow__placeholder-sub {
  font-size: 13px;
  color: #6A6A8A;
  margin-bottom: 20px;
}
.gx-ow__placeholder-btn {
  height: 36px;
  padding: 0 20px;
  border-radius: 8px;
  cursor: pointer;
  background: linear-gradient(135deg, #D4A946, #E8C778);
  border: none;
  font-size: 13px;
  font-weight: 600;
  color: #F4F6F8;
}

</style>
